/*
 * Allows you to manage automated negotiation actions for simple negotiation issues
 */
import React, { useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import AutomatedNegotiationActionControls from './automated_negotiation_action_controls.js.jsx'
import ExpertNeutralToggle from './expert_neutral_toggle.js.jsx'
import ExpertNeutralToggleNJ from './expert_neutral_toggle_nj.js.jsx'
import PartyMessages from './party_messages.js.jsx'
$("[rel=tooltip]").tooltip({html:true,overflow:true});
export default class AutomatedNegotiationsActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      endEnabled: false,
      showModal: false,
      showAna: false,
      activeSessions: false,
      focusedANA: -1,
      isFinal: false,
      declareFinal: false,
      anaToggle: false,
      partyChatToggle: false,
      mentorChatToggle: false,
      other_visible_proposal: null,
      party_text: "",
      mentor_text: "",
      playing_moves: false,
      automated_negotiation_actions: [],
      final_automated_negotiation_action: {},
      grid_values: [],
      timeout: 0
    };
    this.partyExpand = React.createRef();
    this.partyButton = React.createRef();
    this.mentorExpand = React.createRef();
    this.mentorButton = React.createRef();
    this.mentorContainer = React.createRef();
    this.partyContainer = React.createRef();
    this.ent = React.createRef();
    this.toggleDivPartyChat = React.createRef();
    this.toggleDivMentorChat = React.createRef();
    this.toggleDivAna= React.createRef();

  }

  componentDidMount() {
    var scope = this;
    $('#automate-negotiation-btn').click(function() {
      scope.open();
    });
    $('[data-toggle="tooltip"]').tooltip({html:true});
    // quick fix, should be better
    this.loadAutomatedNegotiationActions();
    //this.saveAutomatedNegotiationActions();
    setInterval(this.loadAutomatedNegotiationActions, 5000);
  }
  componentDidUpdate() {
    $('[data-toggle="tooltip"]').tooltip({html:true,overflow:true});
  }
  loadAutomatedNegotiationActions = () => {
    var scope = this;
    $.ajax({
      url: "/api/v1/negotiations/" + this.props.negotiation_id + "/automated_negotiation_actions",
      dataType: 'json',
      success: (data) => {
        ////console.log("this");
        ////console.log(this);
        //this.setState({automated_negotiation_actions: data[0].automated_negotiation_actions.sort(function (a, b) { return a.session - b.session; }) });
        this.setState({endEnabled: data[0].end_enabled});
        this.setState({isFinal: data[0].is_final});
        this.setState({grid_values: data[0].grid_values});
        console.log("loadAutomated - handle next");
        //this.handlePlayingChange(data[0].playing_moves);
        if (data[0].other_visible_proposal == null){
          this.setState({other_visible_proposal: data[0].grid_values[0]});
        } else {
          this.setState({other_visible_proposal: data[0].other_visible_proposal});
        }
        this.mergeActions(this.mergeState(this.state.automated_negotiation_actions, data[0].automated_negotiation_actions.sort(function (a, b) { return a.session - b.session; })), data[0].issue_values.sort(function (a, b) { return a.session_number - b.session_number; }) )
        setTimeout(this.calcPayments, 500);
      },
      error: function(xhr, status, err) {
        console.error("/api/v1/negotiations/" + this.props.negotiation_id + "/automated_negotiation_actions", status, err.toString());
      }.bind(this)
    });
  }
  submitAutomatedNegotiationActions = () => {
    this.setState({activeSessions: true}, function stateComplete(){
      this.saveAutomatedNegotiationActions();
    }.bind(this));
  }
  setWalkaway = (value) => {
    var index = (this.state.automated_negotiation_actions.length - 1);
    $("#adc-" + index).val(value);
    ////console.log("setWalk");
    //console.log("#adc-" + index);
    var anas = this.state.automated_negotiation_actions
    anas[this.state.automated_negotiation_actions.length-1].automated_issue_actions[0].automatic_deal_closer = value;
    this.setState({ automated_negotiation_actions: anas });
    //console.log(this.state.automated_negotiation_actions);
  }
  saveAutomatedNegotiationActions = (del = false) => {
    var scope = this;
    var post_data = {
      id: this.props.negotiation_id,
      automated_negotiation_actions_attributes: scope.state.automated_negotiation_actions
    };
    var clean_post = {};
    clean_post.id = this.props.negotiation_id;
    clean_post.automated_negotiation_actions_attributes = scope.state.automated_negotiation_actions.filter(function(a){return true});
    // Massage the data for rails
    for (var i = 0; i < clean_post.automated_negotiation_actions_attributes.length; i++) {

      var ana = clean_post.automated_negotiation_actions_attributes[i];
      if(!ana.session) ana.session = i + 1;
      ana.automated_issue_actions_attributes = ana.automated_issue_actions;
      ana.automated_issue_actions_attributes.map(function(aia, i){
        if(!aia.issue_id) aia.issue_id = scope.props.issue_id;
      });

      // Remove completed anas from post data to prevent 'editing completed' confusion
      //console.log("active?");
      //console.log(this.state.activeSessions);
     if ((ana.automated_issue_actions[0].visible != null) && (ana.automated_issue_actions[0].visible != "") && ((ana.automated_issue_actions[0].secret == null) || (ana.automated_issue_actions[0].secret == ""))){
        ana.automated_issue_actions[0].secret = ana.automated_issue_actions[0].visible;
      }

      if((ana.completed) || ((((ana.automated_issue_actions[0].secret == null) || (ana.automated_issue_actions[0].secret == "")) && ((ana.automated_issue_actions[0].visible == null) || (ana.automated_issue_actions[0].visible == "")) && ana._destroy != true ))){
        if (ana.final == false){
          var result = clean_post.automated_negotiation_actions_attributes.splice(i, 1);

          if (result != undefined && result.length > 0){
          // since the array shifts left we need to start at the current index again
            i -= 1;
          }
        }
      } else if (ana.final){
        //console.log(ana);
        ana.declare_final = true;
        if (ana.automated_issue_actions[0].visible == null && ana.automated_issue_actions[0].secret == null){
          var result = clean_post.automated_negotiation_actions_attributes.splice(i, 1);
          if (result != undefined && result.length > 0){
            i -= 1;
          }
        } 
      }

    }
    
      console.log("clean_post");
      console.log(clean_post);

		$.ajax({
      url: "/api/v1/negotiations/" + this.props.negotiation_id + "/automated_negotiation_actions/bulk_update",
      dataType: 'json',
      type: "PUT",
      data: {negotiation: clean_post},
      success: function(data) {
        this.setState({endEnabled: data[0].end_enabled});
        this.setState({isFinal: data[0].is_final});
        this.setState({grid_values: data[0].grid_values});
        if (data[0].other_visible_proposal == null){
          this.setState({other_visible_proposal: data[0].grid_values[0]});
        } else {
          this.setState({other_visible_proposal: data[0].other_visible_proposal});
        }

        console.log("bulk callback");
        if (del == true){
          //this.setState({automated_negotiation_actions: this.state.automated_negotiation_actions.slice(0,this.state.automated_negotiation_actions.length-2)});
        }
        //this.mergeActions(this.mergeState(this.state.automated_negotiation_actions, data[0].automated_negotiation_actions.sort(function (a, b) { return a.session - b.session; })), data[0].issue_values.sort(function (a, b) { return a.session_number - b.session_number; }) )
        //console.log(this.state.automated_negotiation_actions);

        this.mergeActions(this.mergeState(this.state.automated_negotiation_actions, data[0].automated_negotiation_actions.sort(function (a, b) { return a.session - b.session; })), data[0].issue_values.sort(function (a, b) { return a.session_number - b.session_number; }) )
        //this.mergeActions(data[0].automated_negotiation_actions.sort(function (a, b) { return a.session - b.session; }), data[0].issue_values.sort(function (a, b) { return a.session_number - b.session_number; }) )
        //console.log(this.state.automated_negotiation_actions);
        //console.log("after bulk");
        //console.log(this.state.automated_negotiation_actions);
        setTimeout(this.calcPayments, 500);
        var successMessage = this.state.activeSessions ? I18n.components.automated_negotiation.automated_action_submitted : I18n.components.automated_negotiation.automated_action_saved;
        this.setState({activeSessions: false});
        /*
        $.notify({
          icon: 'fa fa-check',
          title: I18n.components.automated_negotiation.success,
          message: successMessage
        },{ type: "success", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 5000 });
        */
      }.bind(this),
      error: function(xhr, status, err) {
        //this.setState({private_reference_package: xhr.responseJSON.private_reference_package});

        $.notify({
          icon: 'fa fa-times',
          title: "", //I18n.components.automated_negotiation.oops,
          message: xhr.responseJSON[0] || I18n.components.automated_negotiation.save_failed
        },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
      }.bind(this)
    });
  }
  togglePartyExpand = () => {
    window.jQuery("#partyChatContainer").toggleClass('fullscreen');
    window.jQuery("#iconPartyExpand").toggleClass('fa-expand');
    window.jQuery("#iconPartyExpand").toggleClass('fa-close');
    window.jQuery("#btnPartyButton").toggleClass('btn-danger');
  }

  toggleMentorExpand = () => {
    window.jQuery("#mentorChatContainer").toggleClass('fullscreen');
    window.jQuery("#iconMentorExpand").toggleClass('fa-expand');
    window.jQuery("#iconMentorExpand").toggleClass('fa-close');
    window.jQuery("#btnMentorButton").toggleClass('btn-danger');
  }
  newAutomatedNegotiationAction = () => {
    // look for earliest set to destroyed and replace it
    if (this.state.isFinal == true){
      return 0;
    }
    let filtered = this.state.automated_negotiation_actions;
    let tmp = filtered.findIndex(function(item, index){if (item._destroy === true){return true;}});
    ////console.log(tmp);
    if (tmp != -1){
      //console.log("newAutomatedAction: filtered");
      filtered[tmp] = { session: filtered[tmp].session, automated_issue_actions: [{ secret: "", visible: "" , issue_id: this.props.issue_id}]};
      /*
      filtered[tmp].id = null;
      filtered[tmp].automated_issue_actions[0].automated_negotiation_action_id = null;
      filtered[tmp].automated_issue_actions[0].secret = null;
      filtered[tmp].automated_issue_actions[0].visible = null;
      filtered[tmp].completed = false;
      filtered[tmp]._destroy = false;*/
      this.setState({ automated_negotiation_actions: filtered });
    } else {
      this.state.automated_negotiation_actions.push({ session: this.state.automated_negotiation_actions.length, automated_issue_actions: [{ secret: "", visible: "" , issue_id: this.props.issue_id}]});
      this.state.automated_negotiation_actions = _.sortBy(this.state.automated_negotiation_actions, ['session']);
      //console.log("newAutomatedAction: NOT filtered");
      //console.log(this.state.automated_negotiation_actions);
      this.setState({ automated_negotiation_actions: this.state.automated_negotiation_actions });
    }
  }

  clearValues(obj) {
    if ((obj.automated_issue_actions[0].secret == "") && (obj.automated_issue_actions[0].visible == "")){
      return
    }
    obj.automated_issue_actions[0].secret = "";
    obj.automated_issue_actions[0].visible = "";
    this.saveAutomatedNegotiationActions();
    this.setState({activeSessions: false});
    this.saveParty();
  }
  markForDeletion(obj) {
    //var newArr = this.state.automated_negotiation_actions.filter(function(ana) {return obj.session !== ana.session});
    //this.setState({automated_negotiation_actions: newArr});

    if ((this.state.automated_negotiation_actions[obj.session-1] != null) && (this.state.automated_negotiation_actions[obj.session-1].final != true)){
      obj.automated_issue_actions[0].secret = this.state.automated_negotiation_actions[obj.session-1].automated_issue_actions[0].secret;
      obj.automated_issue_actions[0].visible = this.state.automated_negotiation_actions[obj.session-1].automated_issue_actions[0].visible;
      if (((obj.automated_issue_actions[0].secret == null) || (obj.automated_issue_actions[0].secret == "")) && ((obj.automated_issue_actions[0].visible == null) || (obj.automated_issue_actions[0].visible == ""))){
        obj._destroy = true;
      }
      obj._destroy = true;
      var anas = this.state.automated_negotiation_actions;
      anas[obj.session-1]._destroy = true;
      //this.state.automated_negotiation_actions.splice(obj.session, 1);
      //this.setState(this.state);
      this.saveAutomatedNegotiationActions(del = true);
    }
    //this.state.automated_negotiation_actions[obj.session]._destroy = true;
    //obj._destroy = true;
    this.setState({activeSessions: false});
    this.saveParty();
    //console.log("deleting");
    //console.log(obj);
    //this.state.automated_negotiation_actions.splice(obj.session -1, 1);
    ////console.log(delarray);
    //this.setState(this.state);
  }
  mergeState(oldarray, current){
    //console.log("mergeState before: oldarray");
    //console.log(oldarray);
    //console.log("mergeState before: current");
    //console.log(current);
    var newactions = [];
    var old = [];
    var push_final = -1;
    for (var i = 0; i< oldarray.length; i++){
      if (oldarray[i].session == 99){
        push_final = i;
      } else {
        old[oldarray[i].session -1] = oldarray[i];
      }
    }
    if (push_final > 0){
      //oldarray[push_final].automated_issue_actions[0].visible = 12000;
      old.push(oldarray[push_final]);
    }
    var tempold= old;
    for (var i = 0; i < current.length; i++){
      if (i == current.length-1){
        if (!this.actionExists(old[old.length-1]) || (this.actionExists(old[old.length-1]) && !old[old.length-1].final)|| current[i].completed){
          if (old[old.length -1].final && current[i].completed){
            //console.log("ste1");
            //console.log(i);
            old[old.length-1] = current[i];
          } else {
            //console.log("ste2");
            //console.log(i);
            old.push(current[i]);
          }
        } else if ((this.actionExists(old[old.length-1]) && old[old.length-1].final) && (current[i].final)){
          //console.log("ste6");
          //console.log(i);
          old[old.length-1].completed = current[i].completed;
        }
      } else if (!this.actionExists(old[current[i].session-1]) || current[i].completed){
        if ((old[current[i].session-1] && old[current[i].session-1]._destroy != true) || old[current[i].session-1] == null){
          //console.log("ste3");
          //console.log(i);
          old[current[i].session-1] = current[i];
        }
      } else if ((old[current[i].session-1].automated_issue_actions[0].secret == current[i].automated_issue_actions[0].secret) && 
        (old[current[i].session-1].automated_issue_actions[0].visible == current[i].automated_issue_actions[0].visible)){

        //console.log("ste4");
        //console.log(i);
        old[current[i].session-1] = current[i];
      } else if ((this.actionExists(old[old.length-1]) && old[old.length-1].final) && (current[i].final)){
        //console.log("ste5");
        //console.log(i);
        old[old.length-1].completed = current[i].completed; 
      }
    }
    ////console.log(old);
    var newarray = _.sortBy(old, ['session']);
    //console.log("mergeState after: old");
    //console.log(old);

    return old;
  }
  actionExists(ana){
    return (ana != null && ana.session != null && !ana._destroy)
  }
  // merges the manual moves taken from issue_actions into the automated moves, it should mark manual moves that are already finished as completed.
  mergeActions(auto, manual){
    // faster merge if final is completed
    if ((auto[auto.length - 1].final == true) && (auto[auto.length - 1].completed == true)){
      var manarr = [];
      for (var i = 0; i < (manual.length - 1); i++){
        // check for duplicate
        if ((i == 0) || (manarr.map(x => x.session_number).indexOf(manual[i].session_number) == -1)){
          manarr.push({ session: manual[i].session_number, completed: (i != manual.length-1), automated_issue_actions: [{ secret: manual[i].acceptance, visible: manual[i].visible_proposal , issue_id: this.props.issue_id}]});
        }
      }
      manarr.push(auto[auto.length - 1]);
      this.setState({ automated_negotiation_actions: manarr }, function isComplete(){
        //console.log("state manual");
        //console.log(manarr);

       return
     });
      return
    }
    //console.log("preauto");
    //console.log(auto);
    //console.log("manual");
    //console.log(manual);

    // puts the sessions in the correct indexes and puts the final session at the end of the array
    if (manual.length >= auto.length){
      var old = [];
      var pushfinal = -1;
      for (var i = 0; i< manual.length; i++){
        if ((auto[i] == null)){
          old[i] = null;
        } else if (auto[i] && auto[i].final){
          old[i] = null
          pushfinal = i;
        } else {
          old[auto[i].session -1] = auto[i];
        }
      }
      if (pushfinal > 0){
        if(old[old.length-1] != null){
          old.push(auto[pushfinal]);
        } else {
          old[old.length-1] = auto[pushfinal];
        }
      }
      auto = old;
    }
    //console.log("mid auto");
    //console.log(auto);

    var lindex = manual.length;

    for (var i = 0; i < lindex; i++){

      // creates a new automated action if none exists for the session
      if (auto[manual[i].session_number-1] == null){
        auto[manual[i].session_number-1] = { session: manual[i].session_number, automated_issue_actions: [{ secret: manual[i].acceptance, completed: true, visible: manual[i].visible_proposal , issue_id: this.props.issue_id}]};
      }

      // last move and final is true, update final
      if ((i == (manual.length - 1)) && this.state.isFinal == true){
        auto[auto.length-1].automated_issue_actions[0].secret = manual[i].acceptance;

        auto[auto.length-1].automated_issue_actions[0].visible = manual[i].visible_proposal;
        auto[auto.length-1].completed = false;
      // last move and it is not final, update the corresponding session
      } else if ((i == (manual.length - 1)) && auto[i].final != true){
        auto[i].automated_issue_actions[0].secret = manual[i].acceptance;

        auto[i].automated_issue_actions[0].visible = manual[i].visible_proposal;
        auto[i].completed = false;
      } else if ((i == (manual.length - 1)) && auto[i].final == true){
        // last move and corresponding space is final (there's no session for that move)
        // do nothing

        // move is completed
      } else{
        auto[manual[i].session_number-1].automated_issue_actions[0].secret = manual[i].acceptance;

        auto[manual[i].session_number-1].automated_issue_actions[0].visible = manual[i].visible_proposal;
        auto[manual[i].session_number-1].completed = true;
      }

    }

    if (this.state.isFinal == true){
      var old = [];
      for (var i = 0; i < auto.length; i++){
        if (auto[i] != null && (auto[i].completed || auto[i].final)){
          old.push(auto[i]);
        }
      }
      auto = old;
    }
    //auto = _.sortBy(auto, ['session']);
    //console.log("removed completed?");
    //console.log(auto);
    this.setState({ automated_negotiation_actions: auto });
    // automatically add new row
    /*
    if ((this.state.automated_negotiation_actions[this.state.automated_negotiation_actions.length - 2].automated_issue_actions[0].secret != "") && (this.state.automated_negotiation_actions[this.state.automated_negotiation_actions.length - 2].automated_issue_actions[0].visible != "") &&
        (this.state.automated_negotiation_actions[this.state.automated_negotiation_actions.length - 2].automated_issue_actions[0].secret != null) && (this.state.automated_negotiation_actions[this.state.automated_negotiation_actions.length - 2].automated_issue_actions[0].visible != null)){ 
      this.newAutomatedNegotiationAction();
      }*/
  }
  close() {
    this.setState({ showModal: false });
    // FIXME: Might not be needed depending on the context. Need better state syncing between controls widget.
    location.reload();
  }

  open() {
    this.setState({ showModal: true });
  }

  handlePlayingChange = (isPlaying) => {
    if (isPlaying == true){
      var pref = this.state.grid_values[0] - this.state.grid_values[this.state.grid_values.length - 1]
      var allFilled = true;
      var saveParty = false;
      if ((this.props.chat_enabled == false) && (this.refs.ent != undefined) && (this.refs.ent.state.expert_neutral_dealcloser == null)){
          if (this.refs.ent.state.expert_neutral_terms == true){
            $.notify({
              icon: 'fa fa-times',
              title: "", //I18n.components.automated_negotiation.oops,
              message: "Pour mandater un Tiers Indépendant pour résoudre votre litige, vous devez 1) accepter les termes du mandat et 2) confirmer donner mandat à un Tiers Indépendant ."
            },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 5000 });
          } else {
            $.notify({
              icon: 'fa fa-times',
              title: "", //I18n.components.automated_negotiation.oops,
              message: I18n.components.automated_negotiation.select_end
            },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 5000 });
          }
          this.saveParty();
          return;
      }
      if ((this.props.chat_enabled == true) && (this.refs.ent != undefined) && (!$("#end_check_true")[0].checked && !$("#end_check_false")[0].checked)){
          $.notify({
            icon: 'fa fa-times',
            title: "", //I18n.components.automated_negotiation.oops,
            message: I18n.components.automated_negotiation.select_end
          },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 5000 });
          this.saveParty();
          return;
      }

      if ((this.props.chat_enabled == false) && (this.refs.ent != undefined) && (this.refs.ent.state.expert_neutral_dealcloser == false) && (this.refs.ent.state.expert_neutral_terms == true)){
          $.notify({
            icon: 'fa fa-times',
            title: "", //I18n.components.automated_negotiation.oops,
            message: "Pour mandater un Tiers Indépendant pour résoudre votre litige, vous devez 1) accepter les termes du mandat et 2) confirmer donner mandat à un Tiers Indépendant. Si vous ne le souhaitez pas, cliquez uniquement sur « Non, je ne souhaite pas. »"
          },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 5000 });
          this.saveParty();
          return;
      }

      for (var i = 0; i < this.state.automated_negotiation_actions.length; i++){
        var ana = this.state.automated_negotiation_actions[i];
        if ((ana.automated_issue_actions[0].visible != null && ana.automated_issue_actions[0].secret != null) && (ana.automated_issue_actions[0].visible != "" && ana.automated_issue_actions[0].secret != "") && (((ana.automated_issue_actions[0].visible - ana.automated_issue_actions[0].secret) * pref) > 0)){
          if (pref < 0){
            $.notify({
              icon: 'fa fa-times',
              title: "",//I18n.components.automated_negotiation.oops,
              message: I18n.components.automated_negotiation.secret_must_be_less
            },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
          } else {
            $.notify({
              icon: 'fa fa-times',
              title: "",//I18n.components.automated_negotiation.oops,
              message: I18n.components.automated_negotiation.secret_must_be_greater
            },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
          }
          this.saveParty();
          return;
        }
      }
      for (var i = 0; i < this.state.automated_negotiation_actions.length; i++){
        ana = this.state.automated_negotiation_actions[i];
        if (ana._destroy || ((ana.automated_issue_actions[0].visible != null && ana.automated_issue_actions[0].secret != null) && (ana.automated_issue_actions[0].visible != "" && ana.automated_issue_actions[0].secret != ""))){
        } else {
          allFilled = false;
        }
      }
      if (allFilled != false){
        this.setState({playing_moves: isPlaying});
      } else {
        this.setState({playing_moves: false});
        $.notify({
          icon: 'fa fa-times',
          title: "Please Fill",
          message: I18n.components.automated_negotiation.secret_must_be_greater
        },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
        this.saveParty();
        return;

      }
    } else {
      this.setState({playing_moves: isPlaying});
    }
  }
  replaceWalkaway(secret, walk, pref){
    //console.log(secret);
    //console.log(walk);
    //console.log(pref);
    if(pref < 0){
      if (parseInt(secret, 10) < parseInt(walk, 10)){
        return true;
      } else {
        return false;
      }
    } else {
      if (parseInt(secret, 10) > parseInt(walk, 10)){
        return true;
      } else {
        return false;
      }
    }
  }
  handleWalkawayChange(obj, event){
    const pluck_secrets = (arr) => arr.map(i => i["automated_issue_actions"][0].secret);
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    var index = target.id.split("-")[1];
    var ana = this.state.automated_negotiation_actions[index];
    const oldvalue = obj[name];
    obj[name] = value;
    //console.log("obj[name]");
    //console.log(ana);
    this.setState(this.state);
    if(this.state.timeout != 0){
      clearTimeout(this.state.timeout);
      this.setState({timeout: 0});
    }
    this.setState({timeout: setTimeout(() => {
      //search function
      this.saveParty();
      this.saveAutomatedNegotiationActions();
      //console.log("timed out");

    }, 1000)});
  }
  handleInputChange(obj, event) {
    const pluck_secrets = (arr) => arr.map(i => i["automated_issue_actions"][0].secret);
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    var index = target.id.split("-")[1];
    var ana = this.state.automated_negotiation_actions[index];
    const oldvalue = obj[name];
    obj[name] = value;
    //console.log("obj[name]");
    //console.log(obj[name]);
    // need to change this to only do it if the secret is more favourable to the user so it depends if they're a high/low user
    var final_index = this.state.automated_negotiation_actions.length - 1
    var pref = this.state.grid_values[0] - this.state.grid_values[this.state.grid_values.length - 1]
    // check for secret too low
    if ((ana.automated_issue_actions[0].visible != null && ana.automated_issue_actions[0].secret != null) && (ana.automated_issue_actions[0].visible != "" && ana.automated_issue_actions[0].secret != "") && (((ana.automated_issue_actions[0].visible - ana.automated_issue_actions[0].secret) * pref) > 0)){
      if (name == "visible"){
        obj["secret"] = value;
        //console.log(name);
        //console.log(obj[name]);
      } else {
        obj["visible"] = value;
        //console.log(name);
        //console.log(obj[name]);
      }
      if (pref < 0){
        $.notify({
          icon: 'fa fa-times',
          title: "",//I18n.components.automated_negotiation.oops,
          message: I18n.components.automated_negotiation.secret_must_be_less
        },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
      } else {
        $.notify({
          icon: 'fa fa-times',
          title: "",//I18n.components.automated_negotiation.oops,
          message: I18n.components.automated_negotiation.secret_must_be_greater
        },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
      }
      //this.saveParty();
      // so it doesn't go through with the save, if we change to snapping the values to the offending new value then this isn't needed
      //return;
    }

    this.setState(this.state, function stateComplete(){
      if (true) {//((ana.automated_issue_actions[0].secret != null) && (ana.automated_issue_actions[0].visible != null) && (ana.automated_issue_actions[0].secret != "") && (ana.automated_issue_actions[0].visible != "")){
        //var sorted_secrets = pluck_secrets(this.state.automated_negotiation_actions).filter(elm => elm).sort((a, b) => a.match(/\d+/) - b.match(/\d+/));
        if (false){//(this.replaceWalkaway(ana.automated_issue_actions[0].secret, this.state.automated_negotiation_actions[final_index].automated_issue_actions[0].automatic_deal_closer, pref) || (this.state.automated_negotiation_actions[final_index].automated_issue_actions[0].automatic_deal_closer == null) || (this.state.automated_negotiation_actions[final_index].automated_issue_actions[0].automatic_deal_closer == "")){
          if (pref < 0){
            adc = sorted_secrets[0];
          } else {
            adc = sorted_secrets[sorted_secrets.length - 1];
          }

          this.state.automated_negotiation_actions[final_index].automated_issue_actions[0].automatic_deal_closer = adc;
        }
        this.saveParty();
        this.saveAutomatedNegotiationActions();
        //console.log("index");
        //console.log(index);
        //console.log(this.state.automated_negotiation_actions.length - 2);
      }
    }.bind(this));

  }
  handleToggle(ischecked){
    this.setState({declareFinal: ischecked});
  }
  togglePlay(istog) {
    this.setState({ declareFinal: !this.state.declareFinal });
  }
  toggleClick() {
    this.setState({ declareFinal: !this.state.declareFinal });
  }
  handleFocus(scope, aia){
    var i = parseInt(aia.target.id.split("-")[1])
    this.setState({focusedANA: i});
    // set the focus state to the spot on the list
  }
  handleLoseFocus(scope, aia){
    // remove focus state
    this.setState({focusedANA: -1});
  }
  _toggleDiv() {
    //$(this.refs['toggleDivAna']).slideToggle();
    this.setState({anaToggle: !this.state.anaToggle});
    //$(".rotate4").toggleClass("down");
    //$("#ana-wrapper").scrollTop(100000000);
  }
  _togglePartyChat() {
    $(this.refs['toggleDivPartyChat']).slideToggle();
    this.setState({partyChatToggle: !this.state.partyChatToggle});
    $(".rotate2").toggleClass("down");
    $("#party-chat-panel").scrollTop(100000000);
  }
  _toggleMentorChat() {
    $(this.refs['toggleDivMentorChat']).slideToggle();
    this.setState({mentorChatToggle: !this.state.mentorChatToggle});
    $(".rotate3").toggleClass("down");
    $("#mentor-chat-panel").scrollTop(100000000);
  }
  handleMentorTextChange = (event) => {
    this.setState({mentor_text: event.target.value});
  }
  handlePartyTextChange = (event) => {
    this.setState({party_text: event.target.value});
  }
  submitPartyText = (e) => {
    e.preventDefault();
    setTimeout(() => {
        this.setState({ party_text: '' });
    }, 1000);
  }
  mapOptions(row, bid, opt){

    return <option key={bid + "-" + opt + "-" + row}>{opt}</option>;
  }
  toggleAna = () => {
    this.setState({showAna: !this.state.showAna});
  }
  submitMentorText = (e) => {
    e.preventDefault();
    setTimeout(() => {
        this.setState({ mentor_text: '' });
    }, 1000);
  }
  saveParty = () => {
    var scope = this;
    var post_data = {
      id: this.props.party.id,
        play_automated_actions: false
      };
    $.ajax({
      url: '/api/v1/parties/' + this.props.party.id,
      dataType: 'json',
      type: "PUT",
      data: {party: post_data},
      success: function(data) {
        this.handlePlayingChange(false);
        /*
        $.notify({
          icon: 'fa fa-check',
          title: 'Success',
          message: ''
        },{ type: "success", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
        */
      }.bind(this),
      error: function(xhr, status, err) {

        $.notify({
          icon: 'fa fa-times',
          title: '',
          message: xhr.responseJSON || 'Failed to perfom action'
        },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
      }.bind(this)
    });
  }

  render() {
    var scope = this;

    var addNewButton = <Button onClick={scope.newAutomatedNegotiationAction} variant="default" bsSize="small" style={{marginRight: "5px"}}>{I18n.components.automated_negotiation.add_row}</Button>
    var automated_negotiation_action_rows = [];
    var displayRows = [];
    var messageHeader = (
      <th style={{width: "40%"}}>{I18n.components.automated_negotiation.message}</th>
    );
    var delete_index = -1;
    for (var i = scope.state.automated_negotiation_actions.length-2; i > 0; i--){
      //console.log(this.state.automated_negotiation_actions);
      if (!this.state.automated_negotiation_actions[i]._destroy && !this.state.automated_negotiation_actions[i].completed){
        delete_index = this.state.automated_negotiation_actions[i].session;
        break;
      }
    }
    //console.log("deleteindex");
    //console.log(delete_index);
    this.state.automated_negotiation_actions.map(function(ana, i){
      if(!ana._destroy) {

				// This interface only supports 1 issue because of this hack
				if(!ana.automated_issue_actions) ana.automated_issue_actions = [{}];
				var aia = ana.automated_issue_actions[0];

				// Build out error styling objects
				const attributes = ['name', 'increment_amount', 'payments', 'equal_lump_sum', 'visible', 'secret', 'session', 'automatic_deal_closer'];
				var styles = {};
				attributes.map(function(attr) {
					styles[attr] = classNames({
						'form-control': true,
            'has-error': ana.errors && ana.errors[attr],
            'auto-visible': attr == "visible",
            'auto-secret': attr == "secret",
            'auto-walkaway': attr == "automatic_deal_closer"
					});
				});
        var row_style = classNames({
          'active': false });//i % 2 == 1});
        if (!ana.comment) {
          ana.comment = "";
        }
        var played = '';

        if(ana.completed) {
          played = I18n.components.automated_negotiation.locked_after
        } else if(ana.not_played) {
          played = I18n.components.automated_negotiation.skipped_because
        }
        var addButton = <Button onClick={scope.newAutomatedNegotiationAction} variant="default" bsSize="small" style={{marginRight: "5px"}}>{I18n.components.automated_negotiation.add_row}</Button>
        var visibleTipText = I18n.components.automated_negotiation.visible_tooltip_html;
        var secretTipText = I18n.components.automated_negotiation.secret_tooltip_html;
        var adcTipText = I18n.components.automated_negotiation.adc_tooltip_html;
        var colLength = 6;

        var deleteButton = (
          <i className="fa fa-times-circle" onClick={() => { scope.markForDeletion(ana) }} ></i>
        );

        var messageInput = (
          <td><input type="text" className="form-control" placeholder={I18n.components.automated_negotiation.message} value={ana.comment} name="comment" onChange={scope.handleInputChange.bind(scope, ana)} disabled={ana.completed} /></td>
        );

        var sessionInput = (
          ana.session
        );
        var adcInput = (
          <input id={"adc-"+i} min={scope.state.grid_values[0]} data-toggle="tooltip" data-placement="top" data-original-title={adcTipText} type="number" className={styles.automatic_deal_closer} name="automatic_deal_closer" onChange={scope.handleWalkawayChange.bind(scope, aia)} value={aia.automatic_deal_closer} disabled={ana.completed} />
        );
        deleteButton = ((ana.session == (delete_index)) && (ana.session != 1) && !ana._destroy) ? deleteButton : '';
        if(ana.final){
          sessionInput = "Final" //(<div><AutomatedNegotiationActionToggle Name="FSname" party={scope.props.party} handleChange={scope.handleToggle} pausedText="Off" playingText="On" checked={scope.state.declareFinal}/></div>); //I18n.components.automated_negotiation.final_session;
          /*sessionInput = (
            <AutomatedNegotiationActionToggle party={scope.props.party} playingText={"Plneighing"} pausedText={"Pawsed"} divStyle={{margin: '0 auto'}} />
            );*/
          addButton = (
            <Button onClick={scope.newAutomatedNegotiationAction} variant="default" bsSize="small" style={{marginRight: "5px"}}>{I18n.components.automated_negotiation.add_row}</Button>
          );
          //deleteButton = adcInput;
          deleteButton = (
            <i className="fa fa-times-circle" onClick={() => { scope.clearValues(ana) }} ></i>
          );

          visibleTipText = I18n.components.automated_negotiation.visible_ftooltip_html;
          secretTipText = I18n.components.automated_negotiation.secret_ftooltip_html;
          //if Rails.application.secrets.smartsettle_site == 0
          row_style = classNames({'active': false})
          //end
          } else if (ana.session == 1) {
          visibleTipText = I18n.components.automated_negotiation.s1_visible_tooltip_html;
          secretTipText = I18n.components.automated_negotiation.s1_secret_tooltip_html;
          adcInput = '';
        } else {
          adcInput = '';
        }

        if (scope.props.chat_enabled == false){
          messageHeader = '';
          messageInput = '';
          colLength = 5;
        }
        const colStyle = { width: "100%", border: "0px solid black",};

        automated_negotiation_action_rows.push(

          <tr key={i+"-row"} className={row_style} style={{borderTop: (ana.final == true) ? '4px solid #d6e1e5' : '1px solid #d6e1e5'}}>
            <td>
              <div className="row">
                <div className="col-sm-3" style={{display: ((ana.final == true) || (scope.props.chat_enabled == false)) ? 'none' : 'block'}}>
                  {deleteButton}
                </div>
                <div className="col-sm-5" style={{textAlign: "left"}}>
                  {sessionInput}
                </div>
                <div className="col-sm-12" style={{display: ((scope.state.isFinal == true) || (ana.final != true)) ? 'none' : 'block'}}>
                  {deleteButton}
                </div>

              </div>
            </td>
            <td style={{width: "40%"}}>
              <select id={"visible-"+i} data-toggle="tooltip" data-placement="top" data-original-title={visibleTipText} type="number" className={styles.visible} name="visible" value={aia.visible} onChange={scope.handleInputChange.bind(scope, aia)} onFocus={scope.handleFocus.bind(scope, aia)} onBlur={scope.handleLoseFocus.bind(scope, aia)} disabled={ana.completed} >
                <option hidden disabled selected value=""> -- </option>
                {scope.state.grid_values.slice(scope.state.grid_values.indexOf(scope.state.other_visible_proposal)).map(scope.mapOptions.bind(null, "visible", i))}
              </select>
              <small>{played}</small>
            </td>
            <td style={{width: "40%"}}>
              <select id={"secret-"+i} data-toggle="tooltip" data-placement="top" data-original-title={secretTipText} type="number" className={styles.secret} name="secret" value={aia.secret} onChange={scope.handleInputChange.bind(scope, aia)} onFocus={scope.handleFocus.bind(scope, aia)} onBlur={scope.handleLoseFocus.bind(scope, aia)} disabled={ana.completed} >
                <option hidden disabled selected value=""> -- </option>
                {scope.state.grid_values.slice(scope.state.grid_values.indexOf(scope.state.other_visible_proposal)).map(scope.mapOptions.bind(null, "secret", i))}
              </select>
            </td>
          </tr>
        );
        if (ana.final){
          displayRows.push(automated_negotiation_action_rows[automated_negotiation_action_rows.length-1])  
          displayRows.push(
            <tr>
              <td style={{borderTop: 'none'}}>
              </td>
              <td style={{borderTop: 'none'}}>
                Walkaway
              </td>
              <td style={{borderTop: 'none'}}>
                {adcInput}
              </td>
            </tr>
          );
        } else {
          displayRows.push(automated_negotiation_action_rows[automated_negotiation_action_rows.length-1])  
        }

      }
    });

    const AnaPanel = () => (
      <div key="1-cont" className={this.props.chat_enabled ? "col-sm-4" : "col-sm-12"} id="ana-wrapper" style={{marginBottom: '5px'}} ref={this.toggleDivAna}>
        {/* Automated Negotiation Actions */}
        <div style={{width: this.props.chat_enabled ? 'fit-content' : "auto", border: 'solid', borderColor: '#DDDDDD', borderRadius: '8px'}}>
          <div type="button" style={{marginBottom: '10px', width: '100%', textAlign: 'left', backgroundColor: '#DDDDDD'}} className="cursor btn btn-basic btn-xs" ><div className="col-sm-12" style={{fontSize: "15px", padding: "15px 0px", textAlign: 'center'}}>{I18n.components.automated_negotiation.automate_future_moves} </div> </div>
          <table className="table table-responsive">
            <thead>
              <tr>
                <th>{I18n.components.automated_negotiation.session}</th>
                <th>{I18n.components.automated_negotiation.visible}</th>
                <th>{I18n.components.automated_negotiation.secret}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {displayRows}
            </tbody>
          </table>
          <div type="button" style={{marginBottom: '10px', width: '100%', textAlign: 'left', backgroundColor: '#DDDDDD'}} className="cursor btn btn-basic btn-xs" >
            <div className="col-sm-4" style={(this.props.chat_enabled == false)? {display: 'none'} : {ifontSize: "15px", padding: "5px 0px"}}>
              {addNewButton}
            </div>
            <div className="col-sm-8">
              <span className="float-start" style={(this.state.playing_moves == true)? {color: 'green', marginRight: '10px'} : {color: 'red', marginRight: '10px'}}>
                <AutomatedNegotiationActionControls party={this.props.party} parent_toggle={this.state.playing_moves} onPlay={this.handlePlayingChange} />
              </span>
            </div>
          </div>
          <div className="row" style={{marginBottom: '10px', marginLeft: '10px', width: 'fit-content'}}>
            <div className="col-xs-12" style={(this.props.chat_enabled == true)? {display: 'none'} : {}}>
              <ExpertNeutralToggle negotiation_id={this.props.negotiation_id} end_enabled={this.state.endEnabled} ref={this.ent}/>
            </div>
            <div className="col-xs-12" style={(this.props.chat_enabled == false)? {display: 'none'} : {}}>
              <ExpertNeutralToggleNJ negotiation_id={this.props.negotiation_id} end_enabled={this.state.endEnabled} ref={this.ent}/>
            </div>
          </div>
        </div>
      </div>
    )

    const { intervenors_present, default_intervenor_message } = this.props;

    return (
      <div>
        <br/>
        <div className="row">


          <div key="1-cont" className={this.props.chat_enabled ? "col-sm-4" : "col-sm-12"} id="ana-wrapper" style={(this.state.showAna)? {marginBottom: '5px'} : {display: 'none', marginBottom: '5px'}} ref={this.toggleDivAna}>
            {/* Automated Negotiation Actions */}
            <div style={{width: this.props.chat_enabled ? 'fit-content' : "auto", border: 'solid', borderColor: '#DDDDDD', borderRadius: '8px'}}>
              <div type="button" style={{marginBottom: '10px', width: '100%', textAlign: 'left', backgroundColor: '#DDDDDD'}} className="cursor btn btn-basic btn-xs" ><div className="col-sm-12" style={{fontSize: "15px", padding: "15px 0px", textAlign: 'center'}}>{I18n.components.automated_negotiation.automate_future_moves}  <button onClick={this.toggleAna} className="close float-end" ><span aria-hidden="true" style={{fontSize: "20px"}}>&times;</span></button></div></div>
              <table className="table table-responsive">
                <thead>
                  <tr>
                    <th>{I18n.components.automated_negotiation.session}</th>
                    <th>{I18n.components.automated_negotiation.visible}</th>
                    <th>{I18n.components.automated_negotiation.secret}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {displayRows}
                </tbody>
              </table>
              <div type="button" style={{marginBottom: '10px', width: '100%', textAlign: 'left', backgroundColor: '#DDDDDD'}} className="cursor btn btn-basic btn-xs" >
                <div className="col-sm-4" style={(this.props.chat_enabled == false)? {display: 'none'} : {ifontSize: "15px", padding: "5px 0px"}}>
                  {addNewButton}
                </div>
                <div className="col-sm-8">
                  <span className="float-start" style={(this.state.playing_moves == true)? {color: 'green', marginRight: '10px'} : {color: 'red', marginRight: '10px'}}>
                    <AutomatedNegotiationActionControls party={this.props.party} parent_toggle={this.state.playing_moves} onPlay={this.handlePlayingChange} />
                  </span>
                </div>
              </div>
              <div className="row" style={{marginBottom: '10px', marginLeft: '10px', width: 'fit-content'}}>
                <div className="col-xs-12" style={(this.props.chat_enabled == false)? {display: 'none'} : {}}>
                  <ExpertNeutralToggle negotiation_id={this.props.negotiation_id} end_enabled={this.state.endEnabled} ref={this.ent}/>
                </div>
                <div className="col-xs-12" style={(this.props.chat_enabled == true)? {display: 'none'} : {}}>
                  <ExpertNeutralToggleNJ negotiation_id={this.props.negotiation_id} end_enabled={this.state.endEnabled} ref={this.ent}/>
                </div>
              </div>
            </div>
          </div>

          <div key="2-cont" className={(this.state.showAna) ? "col-sm-4" : "col-sm-6"} id="party-chat-wrapper" style={(this.props.chat_enabled == false)? {display: 'none'} : {}} ref={this.toggleDivPartyChat}>
            <div className="panel panel-default chat-container" id="partyChatContainer"ref={this.partyContainer}>
              <div className="panel-heading row">

                <div className="col-sm-1" style={{overflow: 'visible'}}>
                  <i onClick={this.toggleAna} data-toggle="tooltip" data-placement="right" data-original-title={I18n.components.automated_negotiation.automate_your_bids} className="fa fa-play-circle float-start" style={(this.state.showAna == true)? {display: 'none'} : {fontSize: "40px"}} ></i>
                </div>
                <div className="col-sm-9">
                  <h5 className="float-start">
                    <span>
                      {I18n.components.automated_negotiation.group_chat}
                    </span>
                  </h5>
                </div>
                <div className="col-sm-2">
                  <span className="float-end chat-expander">
                    <div className="btn btn-default btn-sm" id="btnPartyButton" ref={this.partyButton} onClick={this.togglePartyExpand}>
                      <i className="fa fa-expand" id="iconPartyExpand" ref={this.partyExpand}></i>
                    </div>
                  </span>
                </div>
              </div>
              <div className="panel-body chat-panel" style={{height: '285px'}}>
                <div className="panel-body chat-panel" id="party-chat-panel" style={{height : '255px'}}>
                  <div>
                    <PartyMessages url={"/negotiations/" + this.props.negotiation_id + "/party_messages?by_party_ids=" + this.props.party.id + "," + this.props.party_2.id + "&user_id=" + this.props.user.id} locale={this.props.user.locale} pollInterval={4000}prerender={true}/>
                  </div>
                </div>
              </div>
              <div className="panel-footer">
                <form className="simple_form new_party_message" onSubmit={this.submitPartyText} id="new_party_message" action={"/negotiations/" + this.props.negotiation_id + "/party_messages"} acceptCharset="UTF-8" data-remote="true" method="post">
                  <div className="form-group hidden party_message_negotiation_id">
                    <div className="col-sm-9">
                      <input className="form-control hidden" value={this.props.negotiation_id} type="hidden" name="party_message[negotiation_id]" id="party_message_negotiation_id" />
                    </div>
                  </div>
                  <div className="form-group hidden party_message_sent_by">
                    <div className="col-sm-9">
                      <input className="form-control hidden" value={this.props.party.id} type="hidden" name="party_message[sent_by]" id="party_message_sent_by" />
                    </div>
                  </div>
                  <div className="form-group text required party_message_message">
                    <div className="col-sm-12">
                      <textarea value={this.state.party_text} style={{width: '100%'}} onChange={this.handlePartyTextChange} className="form-control text required" required="required" aria-required="true" placeholder="Your message" name="party_message[message]" id="party_message_message">
                      </textarea>
                    </div>
                  </div>
                  <input type="submit" style={{marginLeft: '15px', marginTop: '5px'}} name="commit" value="Send Message" class="btn btn-default btn-sm" data-disable-with="Send Message" />
                  <p></p>
                  <div className="alert alert-danger" id="new_party_msg_error" style={{display: 'none'}}>
                  </div>
                  <p></p>
                </form>
              </div>
            </div>
          </div>

          <div key="3-cont" className={(this.state.showAna) ? "col-sm-4" : "col-sm-6"} id="mentor-chat-wrapper" style={(this.props.chat_enabled == false)? {display: 'none'} : {}} ref={this.toggleDivMentorChat}>
            <div className="panel panel-default chat-container" id="mentorChatContainer" ref={this.mentorContainer}>
              <div className="panel-heading row">
                <div className="col-sm-10">
                  <h5>
                    <span>
                      {I18n.components.automated_negotiation.mentor_chat_with} {this.props.intervenor_role}
                    </span>
                  </h5>
                </div>
                <div className="col-sm-2">
                  <span className="float-end chat-expander">
                    <div className="btn btn-default btn-sm" id="btnMentorButton" ref={this.mentorButton} onClick={this.toggleMentorExpand}>
                      <i className="fa fa-expand" id="iconMentorExpand" ref={this.mentorExpand}></i>
                    </div>
                  </span>
                </div>
              </div>
              <div className="panel-body chat-panel" style={{height: '285px'}}>
                <div className="panel-body chat-panel" id="mentor-chat-panel" style={{height : '255px'}}>
                  <div>
                    <PartyMessages url={"/negotiations/" + this.props.negotiation_id + "/party_messages?by_party_ids=" + this.props.party.id + "&to_party_ids=" + this.props.party.id + "&user_id=" + this.props.user.id} locale={this.props.user.locale} pollInterval={4000} prerender={true} default_intervenor_message={this.props.default_intervenor_message} intervenors_present={this.props.intervenors_present}/>
                  </div>
                </div>
                {/*{!intervenors_present && (
                  <div style={{width: '100%', textAlign: 'center', whiteSpace: 'normal', wordWrap: 'break-word', maxWidth: '100%', position: 'relative', bottom: '30px'}}>
                    <em>{default_intervenor_message}</em>
                  </div>
                )}*/} 
              </div>
              <div className="panel-footer">
                {!intervenors_present && (
                  <div style={{width: '100%', textAlign: 'center', whiteSpace: 'normal', wordWrap: 'break-word', maxWidth: '100%'}}>
                    <em>{default_intervenor_message}</em>
                  </div>
                )}
                <form className="simple_form new_party_message" onSubmit={this.submitMentorText} id="new_party_message" action={"/negotiations/" + this.props.negotiation_id + "/party_messages"} acceptCharset="UTF-8" data-remote="true" method="post">
                  <div className="form-group hidden party_message_negotiation_id">
                    <div className="col-sm-9">
                      <input className="form-control hidden" value={this.props.negotiation_id} type="hidden" name="party_message[negotiation_id]" id="party_message_negotiation_id" />
                    </div>
                  </div>
                  <div className="form-group hidden party_message_sent_by">
                    <div className="col-sm-9">
                      <input className="form-control hidden" value={this.props.party.id} type="hidden" name="party_message[sent_by]" id="party_message_sent_by" />
                    </div>
                  </div>
                  <div className="form-group hidden party_message_user_id">
                    <div className="col-sm-9">
                      <input className="form-control hidden" value={this.props.user.id} type="hidden" name="party_message[user_id]" id="party_message_user_id" />
                    </div>
                  </div>

                  <div className="form-group text required party_message_message">
                    <div className="col-sm-12">
                      <textarea style={{width: '100%'}} value={this.state.mentor_text} onChange={this.handleMentorTextChange} className="form-control text required" required="required" aria-required="true" placeholder="Your message" name="party_message[message]" id="party_message_message">
                      </textarea>
                    </div>
                  </div>
                  <input type="submit" style={{marginLeft: '15px', marginTop: '5px'}} name="commit" value="Send Message" class="btn btn-default btn-sm" data-disable-with="Send Message" />
                  <p></p>
                  <div className="alert alert-danger" id="new_party_msg_error" style={{display: 'none'}}>
                  </div>
                  <p></p>
                </form>
              </div> 
            </div>
          </div>

        </div>
      </div>
    );
  }
};
